import { Transition } from '@uirouter/angular';

export function resolveEditMode(transition: Transition) {
  const { editMode } = transition.params();

  return Promise.resolve(editMode);
}
